/* PDP gallery (snippets/product-gallery.liquid) — vanilla JS, no dependencies.
 * One track of slides for desktop and mobile:
 *  - desktop: one image at a time; ← / → step through ALL images; thumbnails (10) follow the active one
 *  - mobile: native swipe (scroll-snap) with the next image peeking in; ← n / N → under the image
 * The server renders only the active slide (LCP). Other slides are built from the JSON image list,
 * and their pictures load only when they are next to the one being viewed.
 * Colour changes: theme.js calls window.bindProductThumbs(sectionId) after a variant render; that
 * now hands over to PdpGallery.sync(), which moves to the selected variant's image.
 */
(function () {
  'use strict';

  var WIDTHS = [360, 480, 600, 800, 1000];
  var SIZES = '(min-width: 1400px) 820px, (min-width: 750px) 58vw, 88vw';
  var THUMBS = 6; // desktop strip: six whole thumbnails, none cut off

  function withWidth(src, w) {
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set('width', String(w));
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function Gallery(root) {
    this.root = root;
    this.sid = root.getAttribute('data-section-id');
    this.track = root.querySelector('[data-pdp-track]');
    this.prev = root.querySelector('[data-pdp-prev]');
    this.next = root.querySelector('[data-pdp-next]');
    this.counter = root.querySelector('[data-pdp-counter]');
    this.thumbs = root.querySelector('[data-pdp-thumbs]');
    var json = root.querySelector('[data-pdp-gallery-images]');
    try { this.images = JSON.parse(json ? json.textContent : '[]'); } catch (e) { this.images = []; }
    this.index = parseInt(root.getAttribute('data-start'), 10) || 0;
    this.slides = [];
    this.scrollTimer = null;

    if (this.images.length < 2 || !this.track) return;
    this.buildSlides();
    this.bind();
    this.go(this.index, true);
  }

  /* Build every slide around the server-rendered one (kept as is, so the LCP image isn't re-downloaded). */
  Gallery.prototype.buildSlides = function () {
    var self = this;
    var server = this.track.querySelector('.pdp-gallery__slide');
    var serverIndex = server ? parseInt(server.getAttribute('data-index'), 10) : -1;
    var template = server ? server.cloneNode(true) : null;
    var frag = document.createDocumentFragment();

    this.images.forEach(function (img, i) {
      var li;
      if (i === serverIndex && server) {
        li = server;
      } else {
        li = template ? template.cloneNode(true) : document.createElement('li');
        li.className = 'pdp-gallery__slide';
        li.setAttribute('data-index', i);
        var pic = li.querySelector('img');
        if (pic) {
          pic.removeAttribute('id');
          pic.removeAttribute('src');
          pic.removeAttribute('srcset');
          pic.removeAttribute('fetchpriority');
          pic.setAttribute('loading', 'lazy');
          pic.setAttribute('width', img.w);
          pic.setAttribute('height', img.h);
          pic.setAttribute('alt', img.alt || '');
          pic.setAttribute('data-image-id', img.id);
        }
      }
      var link = li.querySelector('a');
      if (link) {
        link.setAttribute('href', withWidth(img.src, 1024));
        link.setAttribute('aria-label', 'Open enlarged view, image ' + (i + 1) + ' of ' + self.images.length);
      }
      frag.appendChild(li);
      self.slides[i] = li;
    });
    this.track.replaceChildren(frag);
  };

  /* Load the picture for slide i (and its neighbours) only when needed. */
  Gallery.prototype.load = function (i) {
    for (var k = i - 1; k <= i + 1; k++) {
      var li = this.slides[k];
      var img = li && li.querySelector('img');
      if (!img || img.getAttribute('src')) continue;
      var src = this.images[k].src;
      img.setAttribute('srcset', WIDTHS.map(function (w) { return withWidth(src, w) + ' ' + w + 'w'; }).join(', '));
      img.setAttribute('sizes', SIZES);
      img.setAttribute('src', withWidth(src, 600));
    }
  };

  Gallery.prototype.go = function (i, instant) {
    var n = this.images.length;
    i = Math.max(0, Math.min(n - 1, i));
    this.index = i;
    this.load(i);
    var slide = this.slides[i];
    if (slide) {
      this.track.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'instant' : 'smooth' });
    }
    this.update();
  };

  Gallery.prototype.update = function () {
    var i = this.index;
    var n = this.images.length;
    if (this.prev) this.prev.disabled = i === 0;
    if (this.next) this.next.disabled = i === n - 1;
    if (this.counter) this.counter.textContent = (i + 1) + '/' + n;
    this.renderThumbs();

    // keep the zoom modal's text in step with the image being viewed
    var zoom = document.getElementById('ProductZoomImg');
    if (zoom) {
      zoom.setAttribute('alt', 'Enlarged view of ' + (this.images[i].alt || ''));
      zoom.setAttribute('data-image-id', this.images[i].id);
    }
  };

  /* Thumbnail strip (desktop): 6 whole thumbnails. The strip stays still while the active image is
     one of the middle four; it moves one step only when the active image reaches the first or last
     thumbnail (so clicking an edge thumbnail, or arrowing past it, reveals the next one).
     It can also be moved on its own (trackpad swipe, touch swipe) without changing the image. */
  Gallery.prototype.thumbWindow = function () {
    var n = this.images.length;
    var size = Math.min(THUMBS, n);
    var start = typeof this.thumbStart === 'number' ? this.thumbStart : this.index - 2;
    if (this.index <= start) start = this.index - 1;                 // reached / passed the first
    if (this.index >= start + size - 1) start = this.index - size + 2; // reached / passed the last
    start = Math.max(0, Math.min(start, n - size));
    this.thumbStart = start;
    return { start: start, size: size, n: n };
  };

  Gallery.prototype.shiftThumbs = function (step) {
    var n = this.images.length;
    var size = Math.min(THUMBS, n);
    var start = Math.max(0, Math.min((this.thumbStart || 0) + step, n - size));
    if (start === this.thumbStart) return;
    this.thumbStart = start;
    this.renderThumbs(true);
  };

  Gallery.prototype.renderThumbs = function (keepStart) {
    if (!this.thumbs) return;
    var w = keepStart
      ? { start: this.thumbStart, size: Math.min(THUMBS, this.images.length), n: this.images.length }
      : this.thumbWindow();
    var n = w.n;
    var size = w.size;
    var start = w.start;
    var first = this.thumbs.querySelector('[data-index]');
    var curStart = first ? parseInt(first.getAttribute('data-index'), 10) : -1;
    var count = this.thumbs.querySelectorAll('[data-index]').length;

    if (start !== curStart || count !== size) {
      var focused = this.thumbs.contains(document.activeElement);
      var frag = document.createDocumentFragment();
      for (var k = start; k < start + size; k++) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp-gallery__thumb';
        b.setAttribute('data-index', k);
        b.setAttribute('aria-label', 'Show image ' + (k + 1) + ' of ' + n);
        var im = document.createElement('img');
        im.src = withWidth(this.images[k].src, 160);
        im.width = 80;
        im.height = 80;
        im.alt = '';
        im.loading = 'lazy';
        im.decoding = 'async';
        b.appendChild(im);
        li.appendChild(b);
        frag.appendChild(li);
      }
      this.thumbs.replaceChildren(frag);
      if (focused) {
        var keep = this.thumbs.querySelector('[data-index="' + this.index + '"]');
        if (keep) keep.focus({ preventScroll: true });
      }
    }
    var self = this;
    this.thumbs.querySelectorAll('[data-index]').forEach(function (b) {
      if (parseInt(b.getAttribute('data-index'), 10) === self.index) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
  };

  Gallery.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      if (e.target.closest('[data-pdp-prev]')) { self.go(self.index - 1); return; }
      if (e.target.closest('[data-pdp-next]')) { self.go(self.index + 1); return; }
      var t = e.target.closest('.pdp-gallery__thumb');
      if (t) self.go(parseInt(t.getAttribute('data-index'), 10));
    });

    // swipes (mobile) and trackpad scrolls: work out which slide is in view
    this.track.addEventListener('scroll', function () {
      clearTimeout(self.scrollTimer);
      self.scrollTimer = setTimeout(function () {
        var x = self.track.scrollLeft;
        var best = self.index;
        var bestDist = Infinity;
        for (var k = 0; k < self.slides.length; k++) {
          var d = Math.abs(self.slides[k].offsetLeft - x);
          if (d < bestDist) { bestDist = d; best = k; }
        }
        if (best !== self.index) {
          self.index = best;
          self.load(best);
          self.update();
        }
      }, 80);
    }, { passive: true });

    // arrow keys on the thumbnails
    if (this.thumbs) {
      var acc = 0;
      this.thumbs.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // vertical wheel = page scroll, leave it
        e.preventDefault();
        acc += e.deltaX;
        if (Math.abs(acc) >= 60) { self.shiftThumbs(acc > 0 ? 1 : -1); acc = 0; }
      }, { passive: false });
      var tx = null;
      this.thumbs.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      this.thumbs.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        tx = null;
        if (Math.abs(dx) > 40) self.shiftThumbs(dx < 0 ? 2 : -2);
      }, { passive: true });
      this.thumbs.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        self.go(self.index + (e.key === 'ArrowRight' ? 1 : -1));
        var b = self.thumbs.querySelector('[data-index="' + self.index + '"]');
        if (b) b.focus({ preventScroll: true });
      });
    }

    // layout changes (rotate / resize): keep the active slide aligned
    window.addEventListener('resize', function () { self.go(self.index, true); });
  };

  /* After a colour change: move to the selected variant's image. */
  Gallery.prototype.sync = function () {
    var section = document.getElementById('ProductSection-' + this.sid);
    var script = section && section.querySelector('script[data-selected-variant]');
    if (!script) return;
    var v;
    try { v = JSON.parse(script.textContent); } catch (e) { return; }
    var id = v && v.featured_image && v.featured_image.id;
    if (!id) return;
    for (var i = 0; i < this.images.length; i++) {
      if (this.images[i].id === id) { if (i !== this.index) this.go(i, true); return; }
    }
  };

  var galleries = {};

  /* Build only once the gallery CSS is in effect (track is a flex row); otherwise 200+ unstyled
     slides would stack into a long column for a moment. */
  function styled(root) {
    var track = root.querySelector('[data-pdp-track]');
    return !track || window.getComputedStyle(track).display === 'flex';
  }

  function start(root) {
    if (root.__pdpGallery) return;
    root.__pdpGallery = new Gallery(root);
    galleries[root.getAttribute('data-section-id')] = root.__pdpGallery;
  }

  function boot() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (root) {
      if (root.__pdpGallery || root.__pdpWaiting) return;
      if (styled(root)) { start(root); return; }
      root.__pdpWaiting = true;
      var tries = 0;
      (function wait() {
        if (styled(root) || ++tries > 300) { start(root); return; }
        requestAnimationFrame(wait);
      })();
    });
  }

  window.PdpGallery = {
    sync: function (sectionId) {
      var g = galleries[sectionId];
      if (g && g.images.length > 1) g.sync();
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();